module.exports = __webpack_public_path__ + "img/synclounge-white.9ec6b428.png";